import { MoreOutlined } from '@ant-design/icons'
import { Styles } from '@types'
import { Button, Dropdown, Menu, Table, TableColumnType, TablePaginationConfig, Tag } from 'antd'
import { Products } from 'gadjet-v2-types/dist/model'
import { CreditType, Pagination } from 'gadjet-v2-types/dist/type'
import { creditType } from 'gadjet-v2-types/dist/type/label'

import { BranchProductAction } from '@pages/Authorized/Branch/ProductPage'

import ContentWrapper from '@components/atoms/ContentWrapper'

type Props = {
  loading: boolean
  total: number
  pagination: Pagination
  products: Products[]
  onChangePagination: (pagination: Pagination) => void
  onAction: (action: BranchProductAction, productId: number) => void
}
export default function BranchProductListTable({
  loading,
  total,
  pagination,
  products,
  onChangePagination,
  onAction,
}: Props): JSX.Element {
  const onChange = (_pagination: TablePaginationConfig) => onChangePagination({ ...pagination, ..._pagination })

  const columns: TableColumnType<Products>[] = [
    { key: 'name', dataIndex: 'name', title: '이름' },
    { key: 'description', dataIndex: 'description', title: '설명' },
    {
      key: 'price',
      dataIndex: 'price',
      title: '가격',
      render: (price) => `${price} 크레딧`,
    },
    { key: 'stock', dataIndex: 'stock', title: '재고', render: (stock) => `${stock}개` },
    { key: 'salesAmount', dataIndex: 'salesAmount', title: '판매량', render: (salesAmount) => `${salesAmount}개` },
    {
      key: 'availableCreditType',
      dataIndex: 'availableCreditType',
      title: '크레딧',
      render: (availableCreditType: CreditType[]) =>
        availableCreditType.map((type) => <Tag key={type}>{creditType[type]}</Tag>),
    },
    {
      key: 'productId',
      dataIndex: 'productId',
      title: '',
      width: '80px',
      render: (productId) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="update" onClick={() => onAction('update', productId)}>
                수정
              </Menu.Item>
              <Menu.Item key="delete" onClick={() => onAction('delete', productId)}>
                제거
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreOutlined />} size="large" type="text" />
        </Dropdown>
      ),
    },
  ]

  return (
    <ContentWrapper>
      <Table<Products>
        loading={loading}
        style={styles.table}
        scroll={{ x: true }}
        rowKey={({ productId }) => `${productId}`}
        dataSource={products}
        columns={columns}
        onChange={onChange}
        pagination={{
          total,
          position: ['bottomRight'],
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
      />
    </ContentWrapper>
  )
}

const styles: Styles = {
  table: { whiteSpace: 'pre-wrap', wordBreak: 'keep-all' },
}
